import { Button, ChevronDownIcon, ChevronUpIcon } from "@povio/ui";
import { cx } from "class-variance-authority";

interface IProps {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
  className?: string;
}

const ProfileShowMoreButton = ({ isExpanded, setIsExpanded, className }: IProps) => {
  return (
    <Button
      variant="text"
      size="none"
      icon={isExpanded ? <ChevronUpIcon className="h-6 w-6" /> : <ChevronDownIcon className="h-6 w-6" />}
      onPress={() => setIsExpanded(!isExpanded)}
      className={cx("no-print", className)}
    >
      {isExpanded ? "Collapse" : "Expand"}
    </Button>
  );
};

export default ProfileShowMoreButton;
